import { useMemo } from 'react';

import { MakeFooterLocationNode, MakeSignUpTextNode } from '../utils';
import { EventActivityCardProps } from './types';

export const useEventActivityCardController = ({
  isOnline,
  isFromHome,
  distance,
  applicationsCount,
}: EventActivityCardProps) => {
  const footerNodes = useMemo(() => {
    const nodes = [MakeSignUpTextNode(applicationsCount)];
    const location = MakeFooterLocationNode(distance, isFromHome, isOnline);
    if (location) {
      nodes.unshift(location);
    }

    return nodes;
  }, [isOnline, isFromHome, distance, applicationsCount]);

  return { footerNodes };
};
